import { ISR_EXPLICIT_FULL_ACCESS_CODETABLE, ISR_EXPLICIT_FULL_ACCESS_KEY } from "../constants/applicationConstants";

const normalizeEmail = (value?: string | null) => (value || "").trim().toLowerCase();

export const isIsrAccessReady = (
  allCodeTablesValuesMap: any,
  fetchStatus?: string
) => {
  if (Array.isArray(allCodeTablesValuesMap?.[ISR_EXPLICIT_FULL_ACCESS_CODETABLE])) {
    return true;
  }
  return fetchStatus === "success" || fetchStatus === "error";
};

export const canAccessIsrByEmail = (
  allCodeTablesValuesMap: any,
  loggedInEmail?: string | null
) => {
  const email = normalizeEmail(loggedInEmail);
  if (!email) {
    return false;
  }

  const rows = allCodeTablesValuesMap?.[ISR_EXPLICIT_FULL_ACCESS_CODETABLE];
  if (!Array.isArray(rows)) {
    return false;
  }

  return rows.some((row) => (
    row?.keyName === ISR_EXPLICIT_FULL_ACCESS_KEY
    && normalizeEmail(row?.displayValue) === email
  ));
};
